import api  from '../../../../configs/api'
import Form from '../../../../display/forms/FormElements'

import Person from '../../../../things/Person'
import Thing  from '../../../../things/Thing'

const disabledSuggestions = props =>
{
    const { rel } = props ;
    if( rel instanceof Thing )
    {
        const { subjectOf } = rel ;
        if( subjectOf instanceof Thing )
        {
            const { attendee } = subjectOf ;
            if( attendee instanceof Array && attendee.length > 0 )
            {
                return attendee ;
            }
        }
    }
    return null ;
}

const attendee =
{
    add :
    {
        agree       : 'Ajouter' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez sélectionner une personne en cliquant ci-dessous.' ,
        elements    :
        [
            {
                type       : Form.SEARCH_SELECTOR ,
                clazz      : Person,
                path       : api.people.url ,
                clearLabel : 'Vider' ,
                closeLabel : 'Fermer' ,
                init       :
                {
                    id        : 'value',
                    key       : 'value',
                    label     : 'Participant',
                    autoFocus : false,
                    fullWidth : true,
                    margin    : 'normal',
                    required  : true,
                    type      : 'search',
                    variant   : 'outlined'
                },
                inputProps : { label : 'Participant...' },
                logics     : { disabledSuggestions }
            }
        ],
        fail    : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading : 'Chargement en  cours...' ,

        success : 'Ajout du nouveau participant réussi!' ,
        title   : 'Ajouter un participant'
    },
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer ce participant:' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer le participant ?'
    },
    title : 'participants' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Éditer" ,
        remove : "Supprimer"
    }
};

export default attendee ;
